import * as _4 from 'lodash4';
import { PlannedCourse } from '../../../../../global/builders/planned_course_builder';
import { RouterHelper } from '../../../../../global/helpers/router_helper';
class PreviewTermPlanCourseTileComponentController {
  private plannedCourse: PlannedCourse;
  private courseTitle: string;
  private uniqueId: string;
  constructor(private routerHelper: RouterHelper) {}

  initialize() {
    this.courseTitle = this.plannedCourse.course.cd + ' ' + this.plannedCourse.course.title;
    this.uniqueId = _4.uniqueId();
  }
  $onInit = () => this.initialize();
  $onChanges = () => this.initialize();

  showCourseDetails(event: any) {
    this.routerHelper.findStateAndGo('.course_details', {
      courseDetails: {
        courseNk: this.plannedCourse.course.nk,
        termId: this.plannedCourse.term,
        title: this.courseTitle,
        programSlotId: this.plannedCourse.program_slot
      }
    });
  }
}

class PreviewTermPlanCourseTileComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      plannedCourse: '<'
    };
    this.controller = PreviewTermPlanCourseTileComponentController;
    this.templateUrl =
      'capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_term_plan_course_tile/preview_term_plan_course_tile.html';
  }
}

angular
  .module('capability-ng-academic-planner')
  .component('previewTermPlanCourseTileComponent', new PreviewTermPlanCourseTileComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_term_plan_course_tile/preview_term_plan_course_tile.ts